import React from 'react';
import { FormattedMessage } from 'react-intl';
import {
  addOnProductTypes,
  BTFProductTypes,
  isAdvisoryServicesProduct,
  isCommercialOrAcademicOrDeveloperType,
  isSupportOnlyProductKey,
  serverIdNotRequiredForKeys,
  serverIdRequiredForProductTypes,
} from 'util/mac/helpers';
import { StyledLink } from '../StyledComponents';
import { DetailsRow } from '../DetailsRowContentElements/DetailsRow';
import TextArea from '@atlaskit/textarea';

const OrganizationLine = ({ latestPeriod }) => (
  <DetailsRow
    dataCy="action-section-organization-line"
    label={<FormattedMessage id="mac.licenses.organization" defaultMessage="Organization" />}
    value={latestPeriod.license?.licenseDetails?.organisation}
  />
);

const LicenseKeyLine = ({ latestLicenseDetails, accountId }) => (
  <DetailsRow
    dataCy="action-section-license-key-line"
    label={<FormattedMessage id="mac.licenses.license.key" defaultMessage="License key" />}
    value={
      latestLicenseDetails?.sid ? (
        <TextArea
          cols={26}
          rows={6}
          readOnly
          maxHeight="20vh"
          value={latestLicenseDetails.license}
        />
      ) : (
        <StyledLink href={`/purchase/my/products/edit-server-id/${accountId}`}>
          <FormattedMessage id="mac.licenses.view.license" defaultMessage="View license" />
        </StyledLink>
      )
    }
  />
);

const BTFProductDetails = ({ accountDetails }) => {
  const productPackage = accountDetails.merchandise.productPackage || accountDetails.productPackage;
  const { key, productType } = productPackage;
  const {
    merchandise: { details },
    latestPeriod,
  } = accountDetails;

  const isBTFProduct = BTFProductTypes.includes(productType);

  const isNotSupportOnlyProduct =
    !isSupportOnlyProductKey(key) &&
    !isAdvisoryServicesProduct(key) &&
    isCommercialOrAcademicOrDeveloperType(details.licenseType);

  const shouldShowViewLicenseLink =
    serverIdRequiredForProductTypes.includes(productType) &&
    !addOnProductTypes.includes(productType) &&
    !serverIdNotRequiredForKeys.includes(key);

  return (
    isBTFProduct && (
      <>
        <OrganizationLine latestPeriod={latestPeriod} />
        {isNotSupportOnlyProduct &&
          (shouldShowViewLicenseLink || accountDetails.latestLicense?.license) && (
            <LicenseKeyLine
              latestLicenseDetails={latestPeriod.license.licenseDetails}
              accountId={accountDetails.id}
            />
          )}
      </>
    )
  );
};

export default BTFProductDetails;
